import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, ISubscribersListItem } from '../../interfaces';

export function useSubscribersTable(): ISubscribersListItem[] {
    return useContext(MobXProviderContext).RootStore.subscribersStore.list;
}

export function useSubscribersFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.subscribersStore.filterParams;
}
